import { ReactNode } from "react"
import { Flex, View } from "@/components/wrappers/Spectrum/SpectrumWrapper.tsx"

export function Container({ children }: { children: ReactNode }) {
  return (
    <View flex={1} overflow={"auto"}>
      <Flex height="100%" width="100%">
        {children}
      </Flex>
    </View>
  )
}